import type { QueryClient } from "@tanstack/react-query";
import { handleBack } from "../lib/back.js";
import { FLUSH_EVENT } from "../lib/flush.js";

/**
 * spec08: Android glue, set up once at start in the app only. The back gesture (FR18) and the
 * app lifecycle (FR19): leaving the app saves pending edits, coming back refreshes the data.
 */
export async function initNativeShell(queryClient: QueryClient) {
  const { App } = await import("@capacitor/app");
  await App.addListener("backButton", ({ canGoBack }) => {
    if (handleBack()) return;
    if (canGoBack) window.history.back();
    else void App.exitApp();
  });
  await App.addListener("pause", () => window.dispatchEvent(new Event(FLUSH_EVENT)));
  await App.addListener("resume", () => void queryClient.invalidateQueries());
}
